module.exports = __webpack_public_path__ + "img/icon_1_43.ab9da516.png";